<template>
  <Layout>
    <SubHeader :title="$t('bookmark.title')" slot="sub-header">
      <div slot="sub-header-tab">
        <SubHeaderTab :items="lecturesType"
          :isStaticTab="true"
          :selectedId="selectedLectureType"
          @selectedTab="selectedTab" />
      </div>
    </SubHeader>
    <div slot="body" class="bookmark row">
      <LoadingBounce v-if="busy" class="w-100" />
      <template v-else>

        <template v-if="selectedLectureType === videoLectureType">
          <EmptyContent v-if="bookmarksLecture.length === 0"
            :emptyContentText="$t('bookmark.empty_vidoe_lecture')" />
          <template v-else>
            <div class="col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
              v-for="item in bookmarksLecture" :key="item.id">
              <VideoCard :videoLecture="item"
                :eventLabel="'bookmarked_video_lecture'" />
            </div>
            <InfiniteLoading v-if="bookmarksLecture.length >= 10" @infinite="infiniteHandler" class="w-100">
              <div slot="spinner">
                <LoadingBounce></LoadingBounce>
              </div>
              <span slot="no-results"></span>
              <span slot="no-more"></span>
            </InfiniteLoading>
          </template>
        </template>

        <template v-if="selectedLectureType === cardLectureType">
          <EmptyContent v-if="bookmarksLecture.length === 0"
            :emptyContentText="$t('empty_card_lecture')" />
          <template v-else>
            <div class="col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
              v-for="item in bookmarksLecture" :key="item.id">
              <ImageCard :cardLecture="item"
              :eventLabel="'bookmarked_card_lecture'" />
            </div>
            <InfiniteLoading v-if="bookmarksLecture.length >= 10" @infinite="infiniteHandler" class="w-100">
              <div slot="spinner">
                <LoadingBounce></LoadingBounce>
              </div>
              <span slot="no-results"></span>
              <span slot="no-more"></span>
            </InfiniteLoading>
          </template>
        </template>

      </template>
    </div>
  </Layout>

</template>

<script>
  import { isEmpty } from 'lodash';
  import { mapGetters, mapActions } from 'vuex';

  import InfiniteLoading from 'vue-infinite-loading';

  export default {
    name: 'bookmar',

    data() {
      return {
        page: 1,
        limit: 10,
        selectedLectureType: 1,
        busy: false,
        videoLectureType: 1,
        cardLectureType: 2,
      };
    },

    components: {
      InfiniteLoading,
    },

    computed: {
      ...mapGetters({
        lecturesType: 'getLecturesType',
        filterBookmarks: 'getFilterBookmarks',
        filterBookmarksPosition: 'getFilterBookmarksPosition',
      }),

      bookmarksLecture() {
        return this.filterBookmarks[this.selectedLectureType] || [];
      },

      bookmarksPosition() {
        return this.filterBookmarksPosition[this.selectedLectureType] || 1;
      },
    },

    methods: {
      ...mapActions([
        'fetchSubjects',
        'fetchBookmarksVideoLectures',
        'fetchBookmarksCardLectures',
        'resetBookmarks',
        'resetBookmarksPosition',
      ]),

      selectedTab(item) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: item.id === 1 ? 'bookmarked.type_video' : 'bookmarked.type_card',
          eventAction: 'click',
        });

        this.selectedLectureType = item.id;
      },

      infiniteHandler($state) {
        const filters = {};
        filters.page = this.bookmarksPosition;
        filters.per_page = this.limit;
        Promise.resolve()
          .then(() => {
            if (this.selectedLectureType === 1) {
              return this.fetchBookmarksVideoLectures(filters);
            }
            return this.fetchBookmarksCardLectures(filters);
          })
          .then((data) => {
            if (data.length > 0) {
              return $state.loaded();
            }
            return $state.complete();
          });
      },
    },

    beforeMount() {
      this.resetBookmarks();
      this.resetBookmarksPosition();
      this.busy = true;
      Promise.resolve()
        .then(() => {
          if (isEmpty(this.subjectMap)) {
            return this.fetchSubjects();
          }
          return true;
        })
        .then(() => (
          this.fetchBookmarksVideoLectures()
        ))
        .then(() => {
          this.busy = false;
        });
    },

    watch: {
      selectedLectureType(selected) {
        if (isEmpty(this.bookmarksLecture) && selected === 2) {
          const filters = {};
          filters.page = this.bookmarksPosition;
          filters.per_page = this.limit;
          this.busy = true;
          Promise.resolve()
            .then(() => (
              this.fetchBookmarksCardLectures(filters)
            ))
            .then(() => {
              this.busy = false;
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>

  .bookmark {
    max-width: 946px;
    margin: auto;
    padding: 0px 14px 0px 14px;
  }

</style>


// WEBPACK FOOTER //
// Bookmark.vue?b73cc124